export default __webpack_public_path__ + "static/media/unlock-data-geographies.7d703d25.svg";